"use client";

import React, {
  CSSProperties,
  DetailedHTMLProps,
  ForwardedRef,
  forwardRef,
  HTMLAttributes,
} from "react";
import { darkInspectorTheme, lightInspectorTheme } from "./inspectorTheme";
import { StateInspectorArrow } from "./StateInspectorArrow";

export function StateInspectorDisclosureSection({
  open,
  setOpen,
  title,
  right,
  children,
  colorScheme,
  isFirst,
  style,
}: {
  open: boolean;
  setOpen?: (value: boolean) => void;
  title: React.ReactNode;
  right?: React.ReactNode;
  children: React.ReactNode;
  colorScheme: "light" | "dark";
  isFirst?: boolean;
  style?: CSSProperties;
}) {
  const theme =
    colorScheme === "light" ? lightInspectorTheme : darkInspectorTheme;

  const borderColor =
    colorScheme === "light" ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)";

  return (
    <div
      style={{
        flex: open ? "1 1 0" : "0",
        display: "flex",
        flexDirection: "column",
        ...style,
      }}
    >
      <div
        onClick={() => setOpen?.(!open)}
        style={{
          cursor: "default",
          fontSize: "12px",
          padding: "4px 10px",
          display: "flex",
          alignItems: "center",
          ...(!isFirst && { borderTop: `1px solid ${borderColor}` }),
          ...(open && { borderBottom: `1px solid ${borderColor}` }),
        }}
      >
        {setOpen && (
          <StateInspectorArrow
            expanded={open}
            style={{
              fontSize: theme.ARROW_FONT_SIZE,
              marginRight: theme.ARROW_MARGIN_RIGHT + 1,
              color: theme.ARROW_COLOR,
            }}
          />
        )}
        <span style={{ flex: "1 1 0", userSelect: "none" }}>{title}</span>
        {right}
      </div>
      {open && children}
    </div>
  );
}

export const StateInspectorDisclosureRowInner = forwardRef(
  function StateInspectorDisclosureRowInner(
    props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    forwardedRef: ForwardedRef<HTMLDivElement>
  ) {
    return (
      <div
        style={{
          flex: "1 1 0",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
          ...props.style,
        }}
        {...props}
        ref={forwardedRef}
      />
    );
  }
);
